var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',{attrs:{"pageTitleDividerClass":"primary","bannerSrc":"/assets/image/banner/recipe_banner.png","pageTitle":_vm.$t('label.recipe'),"pageSubtitle":_vm.$t('label.anyOneCanCookWithCookXEcoPack'),"hideLogo":true,"layoutType":"x"}},[_c('transition',{attrs:{"name":"fade-in-up"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }